'use client';

import Script from 'next/script';
import useLanguage from 'helpers/hooks/useLanguage';
import { Order } from 'types/entity/order';
import useShippyProFormId from '../useShippyProFormId';

type Props = {
  order: Order;
};

const ReturnsPage: React.FC<Props> = ({ order }) => {
  const [language] = useLanguage();
  const formId = useShippyProFormId();
  console.log('Formid', formId);
  return (
    formId && (
      <>
        <div id="returnDiv" />
        <Script id="shippypro-return-form">{`var returnFormId=${formId};\nvar preInputTrackingNumber = ${JSON.stringify(order?.orderNumber)};\nvar preInputLanguage = ${JSON.stringify(language.slice(0, 2))};\n(function(e,t,n){var r,i=e.getElementsByTagName(t)[0];if(e.getElementById(n))return;r=e.createElement(t);r.id=n;r.src="https://www.shippypro.com/return-form.js";i.parentNode.insertBefore(r,i)})(document,"script","shippypro-returnform-sdk");`}</Script>
      </>
    )
  );
};

export default ReturnsPage;
